import React, { useState } from "react";
import "./Footer.css";
import "bootstrap/dist/css/bootstrap.min.css";
import "bootstrap/dist/css/bootstrap.css";
import "bootstrap/dist/js/bootstrap.js";
import { Link } from "react-router-dom";

function Footer() {
  const [charCount, setCharCount] = useState(500);
  const [comment, setComment] = useState("");

  const handleGo = () => {
    window.scrollTo(0, 0);
  };
  const handleInputChange = (event) => {
    const inputText = event.target.value;
    if (inputText.length <= 500) {
      setComment(inputText);
      setCharCount(500 - inputText.length);
    }
  };
  // const handleSend = () => {
  //   // if (comment.length === 0) {
  //   //   alert("Please provide your feedback before sending.");
  //   //   return;
  //   // }
  //   // axios
  //   //   .post("http://localhost:3000/comments", { comment })
  //   //   .then((response) => {
  //   //     console.log("hank for your Feedback", comment);
  //   //     alert("Thank for your Feedback");
  //   //     setComment("");
  //   //     setCharCount(100);
  //   //   })
  //   //   .catch((error) => {
  //   //     console.error("Error sending comment:", error);
  //   //   });
  // };

  return (
    <>
      <body>
        <div className="container-fluid bg-dark text-white-50 footer pt-5 mt-3 wow fadeIn">
          <div className="container py-0">
            <div className="row g-5">
              <div className="col-lg-3 col-md-6 footerimg">
                <img src="TabLogo.png" alt="" />
                <br />
                <h3>HERBAL CARTEL</h3>
              </div>
              <div className="col-lg-3">
                <h5 className="col1 text-white mb-4">Get In Touch</h5>
                <p className="col1 mb-1">
                  <i class="fa fa-map-marker-alt me-3"></i>BNPura Lake
                </p>
                {/* <p className="col1 mb-1">
                  <i class="fa fa-phone-alt me-3"></i>+012 345 67890
                </p> */}
                <p className="col1 mb-1">
                  <i class="fa fa-envelope me-3"></i>herbalcartel2024@gmail.com
                </p>
              </div>
              <div className="col-lg-3 col-md-6">
                <h5 className="col text-white mb-4">Quick Links</h5>
                <Link
                  className="btn btn-link text-white-50"
                  to="/Aboutus"
                  onClick={handleGo}
                >
                  About Us
                </Link>
                {/* <Link className="btn btn-link text-white-50">
                  Contactus (herbalcartel2024@gmail.com)
                </Link> */}
                <Link className="btn btn-link text-white-50" to="">
                  Privacy Policy
                </Link>
                <Link className="btn btn-link text-white-50" to="">
                  Terms & Condition
                </Link>
              </div>
              {/*<div className="col-lg-3 col-md-6">
                 <h5 className="text-white mb-4">Overview</h5>
                {/* <Link className="btn btn-link text-white-50" to="/Home1">
                  Home
                </Link> 
                <Link className="btn btn-link text-white-50" to="/Aboutus">
                  Herbal cartel Vision
                </Link>
                <Link className="btn btn-link text-white-50" to="/Aboutus">
                  Botanical Timeline
                </Link>
                <Link className="btn btn-link text-white-50" to="/Aboutus">
                  Our Team
                </Link>
                <Link className="btn btn-link text-white-50" to="/Aboutus">
                  Future Goals
                </Link>
              </div>*/}
              {/* <div className="col-lg-3 col-md-6">
                <h5 className="text-white mb-4">Leave Comment Here</h5>
                <div
                  className="position-relative mx-auto"
                  style={{ maxwidth: "900px" }}
                >
                  <input
                    className="form-control bg-transparent text-white "
                    type="text"
                    placeholder="Feedbacks"
                    style={{ color: "white" }}
                  />
                  <button
                    type="button"
                    className="btn btn-success py-0 px-0 position-absolute bottom-4 end-0 mt-1 me-1"
                  >
                    Send
                  </button>
                </div>
              </div> */}
              <div className="col-lg-3 col-md-6">
                <h5 className="text-white mb-4">Leave Comment Here</h5>
                <div
                  className="position-relative mx-auto"
                  style={{ maxwidth: "900px" }}
                  onChange={handleInputChange}
                >
                  <textarea
                    className="form-control bg-transparent text-white "
                    type="text"
                    placeholder="Feedbacks"
                    style={{ color: "white" }}
                    value={comment}
                    onChange={handleInputChange}
                  />
                  Limit: <span>{charCount}</span> Letters
                  <button
                    type="button"
                    className="btn btn-success py-0 px-0 position-absolute bottom-4 end-0 mt-1 me-1"
                    // onClick={handleSend}
                  >
                    Send
                  </button>
                </div>
              </div>
            </div>
          </div>
          <div className="container">
            <div className="copyright">
              <div className="row">
                <div className="col-md-6 text-center text-md-start mb-3 mb-md-0">
                  &copy;
                  <Link className="border-bottom" to="/">
                    Herb Cartel
                  </Link>
                  , All Right Reserved.
                </div>
                <div className="col-md-6 text-center text-md-end">
                  <div class="footer-menu">
                    <Link to="/Home" onClick={handleGo}>
                      Home
                    </Link>
                    <Link to="/Aboutus" onClick={handleGo}>
                      Aboutus
                    </Link>
                    {/* <Link to="/">FQAs</Link> */}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </body>
    </>
  );
}

export default Footer;
